// src/app/auth/token.interceptor.ts

import { Injectable, Injector, Inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private inj: Injector
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const auth = this.inj.get(AuthService);
    const urlRegex = /^(http|https|ftp|www)/;
    const token = auth.getToken;
    // Set token if user logged in
    if (token) {
      request = request.clone({ headers: request.headers.set('x-Auth-Token', `${token}`) });
    }

    // Set header content-type
    if (!request.headers.has('Content-Type') && request.url.indexOf('login') == -1) {
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    }

    if(request.url.indexOf('login') > -1) {
        request = request.clone({ headers: request.headers.set('Accept', 'application/xhtml+xml')},);
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/x-www-form-urlencoded')},);
    }else{

        // Setting the accept header
        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
    }

    
    // Append base URL
    // if(urlRegex.test(request.url) || (request.url) == "../../../assets/i18n/es.json" || (request.url) == "../../../assets/i18n/en.json") {
    //   request = request.clone({ url: `${request.url}`});  
    // } else {
    //   request = request.clone({ url: `${environment.BASE_API}/${request.url}`});  
    // }
    return next.handle(request);
  }
}


// WEBPACK FOOTER //
// ./src/app/auth/token.interceptor.ts